import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'


const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type ReopenDraftQuotationPayload = {
  quotationId: number
}


export class ReopenDraftQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId }: ReopenDraftQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/reopen_draft/`
    this.init = {
      method: 'POST',
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
